export default [
  {
    path: "/110eb094888f16731984a23f",
    children: [
      {
        path: "10e17fa94b3283e5f0f3a9d6",
        name: "lgaEos",
        meta: {
          title: "L.G.A Examination Officers",
          authRequired: true,
          acc: ['y73397']
        },
        component: () => import("../views/lgaEO/users"),
      },
      {
        path: "1100380c0a9d48da2a95512e",
        name: "newLgaEo",
        meta: {
          title: "New L.G.A Examination Officers",
          authRequired: true,
          acc: ['y16371']
        },
        component: () => import("../views/lgaEO/new"),
      },
      {
        path: "1132d43e4f70e0ebd03e72cc",
        name: "viewLgaEo",
        meta: {
          title: "View L.G.A Examination Officers",
          authRequired: true,
          acc: ['y19182']
        },
        component: () => import("../views/lgaEO/view"),
      },
      {
        path: "11a889707515c11e7c48cec1/:tr",
        name: "editLgaEo",
        meta: {
          title: "Update L.G.A Examination Officers",
          authRequired: true,
          acc: ['y49260']
        },
        component: () => import("../views/lgaEO/edit"),
      },
    ],
  },
];
